_ = require("lodash")
moment = require('moment')

ScatterDataService = ->
  convertScoreCards: (filteredScorecards) ->
    _.map filteredScorecards, (sc) ->
      play_date: sc.play_date.format("YYYY/MM/DD")
      name: "#{sc.club.name} #{sc.course.name}"
      x: sc.total_putt_all_holes
      y: sc.total_shot_all_holes

  calculateRange: (scoreData, goal) ->
    scoreDataWithGoalSettings = scoreData || []

    if goal
      scoreDataWithGoalSettings = _.union scoreDataWithGoalSettings, [
        x: goal.total_putt_all_holes
        y: goal.total_shot_all_holes
      ]

    xRange:
      min: (_.minBy(scoreDataWithGoalSettings, 'x') || { x: 0 }).x - 1
      max: (_.maxBy(scoreDataWithGoalSettings, 'x') || { x: 0 }).x + 1
    yRange:
      min: (_.minBy(scoreDataWithGoalSettings, 'y') || { y: 0 }).y - 1
      max: (_.maxBy(scoreDataWithGoalSettings, 'y') || { y: 0 }).y + 1

  prepareDummyData: ->
    [
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 5
      total_putt_all_holes: 3
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 2
      total_putt_all_holes: 3
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 2.5
      total_putt_all_holes: 2.5
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 4
      total_putt_all_holes: 2.7
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 1
      total_putt_all_holes: 2
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 14
      total_putt_all_holes: 10
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 13
      total_putt_all_holes: 10.5
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 14
      total_putt_all_holes: 11
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 11.5
      total_putt_all_holes: 11.5
    ,
      play_date: moment()
      club:
        name: 'dummy',
      course:
        name: 'dummy'
      total_shot_all_holes: 11
      total_putt_all_holes: 11
    ]

ScatterDataService.$inject = [
]

module.exports = ScatterDataService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/scatter-data/scatter-data-service.coffee